export const Prod_API_URL = "https://cinematiccelebration.in:8081/api/";
export const API_URL = "http://localhost:8081/api/";
